import { render, staticRenderFns } from "./EmailInputV1Properties.vue?vue&type=template&id=8ecba322&"
import script from "./EmailInputV1Properties.vue?vue&type=script&lang=js&"
export * from "./EmailInputV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports